<template>
  <b-modal ref="createTokenModal" title="Neuen Code erstellen">
    <p class="text-center font-weight-bold">
      ACHTUNG! Hiermit wird der vorherige Code ungültig!
    </p>

    <b-row class="justify-content-center m-auto w-100">
      <b-col class="align-middle text-right">Gültig bis:</b-col>
      <b-col class="w-25"><b-form-select v-model="validUntil" :options="validUntilOptions"></b-form-select></b-col>
      <b-col class="align-middle text-left">Uhr</b-col>
    </b-row>

    <template slot="modal-footer">
      <b-btn class="mt-3" variant="danger" block @click="newCode">Bestätigen</b-btn>
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
    </template>
  </b-modal>
</template>
<script>
const start = 9
const end = 17
export default {
  name: 'OnlineTokenModal',
  data: function () {
    const options = []
    for (let i = start; i <= end; i++) {
      options.push(i)
    }

    return {
      registrationId: null,
      validUntil: 0,
      validUntilOptions: options
    }
  },

  mounted: function () {
    const plus5 = (new Date()).getHours() + 5
    this.validUntil = plus5 > end ? end : plus5
  },

  methods: {
    show: function (registrationId) {
      this.registrationId = registrationId
      this.$refs.createTokenModal.show()
    },

    hide: function () {
      this.$refs.createTokenModal.hide()
    },

    newCode: function () {
      this.$refs.createTokenModal.hide()

      let body = {validUntil: this.validUntil}
      this.axios.post('/registrations/' + this.registrationId + '/token', JSON.stringify(body))
        .then((rsp) => this.$emit('token', rsp.data))
        .catch((err) => this.$eventHub.$emit('error', err))
        .finally(this.hide)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/details/OnlineTokenModal.vue